import { Injectable } from '@angular/core';
import { PersonService } from './person.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonImplService extends PersonService {

  constructor(private http: HttpClient) {
    super()
   }

   getPersons(): Observable<any> {
    return this.http.get<any>(`${environment.personApi}/waiting-list`)
  }

}
